  <!-- <template>
    <router-view />
  </template>
<script> -->
<template>


  <Navbar :class="'navbar-fullwidth'" />
  <router-view />

</template>
<script>
import Sidebar from '../components/sidebar/SidebarAdmin.vue'
import Navbar from '../components/navbar/NavbarAdmin.vue'
export default {

  name: 'club-layout',
  components: {
    Navbar, Sidebar
  }
}
</script>

<style>
.navbar-fullwidth {
  width: 100% !important;
  left: 0px !important;
}
</style>